/** One strategy priority: the chip and its one-line meaning in place (from the glossary). */
import { useGlossaryEntry } from "../theme/GxTerm";
import { objectiveTermId } from "./limits";

export function AimChip({ objective, label, picked, disabled, onPick }: {
  readonly objective: string; readonly label: string; readonly picked: boolean; readonly disabled: boolean; readonly onPick: () => void;
}) {
  const entry = useGlossaryEntry(objectiveTermId(objective));
  // The whole tile is the control; its name is the priority, and the one-line meaning is its description.
  return (
    <button type="button" className="gx-chair-aim" aria-pressed={picked} aria-disabled={disabled || undefined} aria-labelledby={`aim-${objective}-n`} {...(entry === undefined ? {} : { "aria-describedby": `aim-${objective}-d` })} onClick={onPick}>
      <span className="gx-chair-aim-n" id={`aim-${objective}-n`}>{label}</span>
      {entry === undefined ? null : <span className="gx-small gx-chair-aim-line" id={`aim-${objective}-d`} data-testid={`chair.aim.${objective}`}>{entry.plain}</span>}
    </button>
  );
}
